"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _axios = _interopRequireDefault(require("axios"));
var _sessionStorage = _interopRequireDefault(require("../../utils/sessionStorage"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../../utils/constants");
var _index = require("../../utils/index");
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E6%8F%92%E4%BB%B6--page
 */

// 防止多次调用插件功能，用变量控制
let flag = false;
function _default({
  key,
  // {number} 用于标识每一个 action 实例的全局唯一且持久化的 key
  data,
  // {object} 数据表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
}) {
  if (!flag) {
    // const { needLogin } = data as any;
    const promotionKeyFormPage = _sessionStorage.default.get(_constants.PROMOTION_KEY) || (0, _index.getQueryString)(_constants.PROMOTION_KEY);
    const formValue = (0, _index.getQueryString)(_constants.FORM_KEY);
    const registerFrom = _jsCookie.default.get(`${_constants.REGISTER_FORM_KEY}${formValue}`) || '0'; //获取cookie中注册渠道
    const isNewCustomer = parseInt(registerFrom, 10) === _constants.CUSTOMER_KEY.NEW ? _constants.CUSTOMER_KEY.NEW : _constants.CUSTOMER_KEY.OLD;
    if (!promotionKeyFormPage) return;
    const params = {
      promotionKey: promotionKeyFormPage,
      isNewCustomer
    };
    (0, _axios.default)({
      method: 'post',
      url: '/render/api/configsolution/bindSubCustomer',
      data: params
    }).then(({
      data
    }) => {
      const _data$data = data.data,
        result = _data$data === void 0 ? {} : _data$data,
        code = data.code;
      // 接口请求成功
      if (code === 0) {
        window.recordBehavior && window.recordBehavior.reportEvent('bind_sub_customer_success');
        // 未登录
      } else if (code === -1000) {
        window.recordBehavior && window.recordBehavior.reportEvent('bind_sub_customer_nologin');
        window.location.href = `${location.origin}/account/login?s_url=${encodeURIComponent(location.href)}&from=${formValue}&forceRedirectsUrl=1`;
        // 其他错误
      } else {
        window.recordBehavior && window.recordBehavior.reportEvent('bind_sub_customer_fail', {
          ext1: result.code || ''
        });
      }
    });
    if (promotionKeyFormPage) {
      _sessionStorage.default.set(_constants.PROMOTION_KEY, (0, _index.getQueryString)(_constants.PROMOTION_KEY));
      _sessionStorage.default.set(_constants.FORCE_REDIRECTS_URL_KEY, '1');
    }
    flag = true;
  }
}